import { render, staticRenderFns } from "./Contatto-password.vue?vue&type=template&id=1fc73c9d"
import script from "./Contatto-password.vue?vue&type=script&lang=js"
export * from "./Contatto-password.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports